// extracted by mini-css-extract-plugin
export var store = "Store-module--store--6880a";